export default "__VITE_ASSET__CU8s$skT__"